// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1B4SQ","content":"RecentSearches_content__2HV1K"};